import { isWebsitePageUrlPlaceholderValue } from 'common/utils/website-replacements-utils'
import { LinkSourceTypeEnum } from '../enums/link-source-type-enum'
import { LinkType } from '../type/link-type'

export const detectLinkSource = (link: LinkType) => {
  if (link.popupid) {
    return LinkSourceTypeEnum.Popup
  }

  if (link.href && link.href.startsWith('%BLOG')) {
    return LinkSourceTypeEnum.Blog
  }

  if (link.href && isWebsitePageUrlPlaceholderValue(link.href)) {
    return LinkSourceTypeEnum.Website
  }

  return LinkSourceTypeEnum.Input
}
